import React from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconRole } from '../../../../../shared/icon/icon'
import { Menu, MenuAdd, MenuDelete, MenuEdit } from '../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { useApiListRoleOrg } from '../../../../../api-new/state/content'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { ColumnLink, ColumnMenu, ColumnYesNo } from '../../../../../shared/table-builder/table-columns'

// The owner role is locked: every organization needs one, so the content API
// refuses to delete it (409 role.owner_undeletable) and the list says so,
// in the API's own words, before anyone tries.
export const OWNER_ROLE_DELETE_HINT = "The owner role can't be deleted: every organization needs an owner role."

export const RoleOrgList = () => {
	const apiListRoleOrg = useApiListRoleOrg()

	const handleReady = async () => await apiListRoleOrg.get()
	const handleDestroyed = () => apiListRoleOrg.init()

	const HeaderMenu = () => (
		<Menu>
			<MenuAdd text='add role' to={'/root/role-org/list/add'} show />
		</Menu>
	)

	return (
		<React.Fragment>
			<BreadcrumbView Icon={IconRole} text='Organization roles'>
				<CardFullHeightScrollY title='Roles' HeaderMenu={HeaderMenu}>
					<TableAgClient apiList={apiListRoleOrg} onReady={handleReady} onDestoryed={handleDestroyed}>
						<ColumnLink field='name' to={(row) => `/root/role-org/list/user/${row.name}`} />
						<ColumnYesNo field='isAutoOwner' header='Auto Owner' />
						<ColumnYesNo field='isAutoUser' header='Auto User' />
						<ColumnYesNo field='isReadOnly' header='Read Only' />
						<ColumnMenu
							menu={(row) => (
								<Menu small>
									<MenuEdit to={`/root/role-org/list/edit/${row.id}`} show />
									<MenuDelete
										to={`/root/role-org/list/edit/${row.id}/delete`}
										disabled={row.isAutoOwner}
										title={row.isAutoOwner ? OWNER_ROLE_DELETE_HINT : undefined}
										show
									/>
								</Menu>
							)}
						/>
					</TableAgClient>
				</CardFullHeightScrollY>
			</BreadcrumbView>
		</React.Fragment>
	)
}
